import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

const MortgageSummaryTable = ({ data }) => {
  const formatCurrency = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return '$0.00';
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD',
      minimumFractionDigits: 2,
    }).format(num);
  };

  if (!data) return <Typography>Sin datos</Typography>;

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      className="mobile-scroll-container"
      sx={{
        mt: 8,
        borderRadius: '14px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E9EE',
        boxShadow: '0 1px 8px rgba(11,18,32,0.06)',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <Table aria-label="resumen de hipoteca">
        <TableBody>
          <TableRow sx={{ bgcolor: '#F7F9FC' }}>
            <TableCell>
              <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#1A1A1A', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Categoría
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#1A1A1A', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Plazo
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#1A1A1A', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Amortización
              </Typography>
            </TableCell>
          </TableRow>

          {[
            { label: 'Número de pagos', term: data.numberOfPaymentsTerm, amort: data.numberOfPaymentsAmortization },
            { label: 'Pago hipotecario', term: formatCurrency(data.paymentPerPeriod), amort: formatCurrency(data.paymentPerPeriod), bold: true },
            { label: 'Capital pagado', term: formatCurrency(data.totalPrincipalPaidTerm), amort: formatCurrency(data.principalAmount) },
            { label: 'Intereses pagados', term: formatCurrency(data.totalInterestPaidTerm), amort: formatCurrency(data.totalInterestPaidAmortization), color: '#D32F2F' },
            { label: 'Costo total', term: formatCurrency(data.totalCostTerm), amort: formatCurrency(data.totalCostAmortization), bold: true, labelBold: true },
            { label: 'Saldo restante', term: formatCurrency(data.remainingBalance), amort: '$0.00', amortColor: '#1E3A5F', amortBold: true },
          ].map((row) => (
            <TableRow key={row.label} sx={{ '&:hover': { bgcolor: '#F9FAFB' }, transition: 'background-color 0.15s ease' }}>
              <TableCell sx={{ color: '#1A1A1A', fontWeight: row.labelBold ? 600 : 400 }}>{row.label}</TableCell>
              <TableCell align="right" sx={{ color: row.color || '#1A1A1A', fontWeight: row.bold ? 600 : 400, fontFeatureSettings: "'tnum'" }}>{row.term}</TableCell>
              <TableCell align="right" sx={{ color: row.amortColor || row.color || (row.bold ? '#1A1A1A' : '#1A1A1A'), fontWeight: row.bold || row.amortBold ? 600 : 400, fontFeatureSettings: "'tnum'" }}>{row.amort}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MortgageSummaryTable;
